/*the-problem*/
/*the-lockfile-changes-too-often*/
/*the-solution*/
/*the---docker-flag*/
/*example*/
/*remote-caching*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Docker",
  "description": "学习如何在 monorepo 中使用 Docker。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "构建 Docker 镜像是部署各种应用的常用方法。但是，从 monorepo 执行此操作有几个挑战。"
  }, {
    "heading": "",
    "content": "¥Building a Docker image is a common way to deploy all sorts of applications. However, doing so from a monorepo has several challenges."
  }, {
    "heading": "问题-the-problem",
    "content": "¥The problem"
  }, {
    "heading": "问题-the-problem",
    "content": "在 monorepo 中，不相关的更改可能会导致 Docker 在部署应用时执行不必要的工作。"
  }, {
    "heading": "问题-the-problem",
    "content": "¥In a monorepo, unrelated changes can make Docker do unnecessary work when deploying your app."
  }, {
    "heading": "问题-the-problem",
    "content": "假设你有一个如下所示的 monorepo："
  }, {
    "heading": "问题-the-problem",
    "content": "¥Let's imagine you have a monorepo that looks like this:"
  }, {
    "heading": "问题-the-problem",
    "content": "你希望使用 Docker 部署 apps/api，因此你创建了一个 Dockerfile："
  }, {
    "heading": "问题-the-problem",
    "content": "¥You want to deploy apps/api using Docker, so you create a Dockerfile:"
  }, {
    "heading": "问题-the-problem",
    "content": "这会将根 package.json 和根锁定文件复制到 Docker 镜像。然后，它将安装依赖，复制应用源代码并启动应用。"
  }, {
    "heading": "问题-the-problem",
    "content": "¥This will copy the root package.json and the root lockfile to the Docker image. Then, it'll install dependencies, copy the app source and start the app."
  }, {
    "heading": "问题-the-problem",
    "content": "你还应该创建一个 .dockerignore 文件，以防止 node_modules 与应用源代码一起复制。"
  }, {
    "heading": "问题-the-problem",
    "content": "¥You should also create a .dockerignore file to prevent node_modules from being copied in with the app's source."
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "¥The lockfile changes too often"
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "Docker 在部署应用方面非常智能。就像 Turborepo 一样，它会尝试执行 尽可能少的工作 的操作。"
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "¥Docker is pretty smart about how it deploys your apps. Just like Turborepo, it tries to do as little work as possible."
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "在我们的 Dockerfile 中，只有当其镜像中的文件与上次运行的文件不同时，它才会运行 npm install。如果没有，它将恢复之前的 node_modules 目录。"
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "¥In our Dockerfile's case, it will only run npm install if the files it has in its image are different from the previous run. If not, it'll restore the node_modules directory it had before."
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "这意味着每当 package.json、apps/api/package.json 或 package-lock.json 发生更改时，Docker 镜像都会运行 npm install。"
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "¥This means that whenever package.json, apps/api/package.json or package-lock.json change, the Docker image will run npm install."
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "听起来很棒 - 直到我们意识到一些事情。package-lock.json 对于 monorepo 来说是全局的。这意味着如果我们在 apps/web 中安装一个新包，就会导致 apps/api 重新部署。"
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "¥This sounds great - until we realize something. The package-lock.json is global for the monorepo. That means that if we install a new package inside apps/web, we'll cause apps/api to redeploy."
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "在大型的 monorepo 中，这可能会导致大量时间损失，因为对 monorepo 的 lockfile 的任何更改都会级联到数十或数百个部署中。"
  }, {
    "heading": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "¥In a large monorepo, this can result in a huge amount of lost time, as any change to a monorepo's lockfile cascades into tens or hundreds of deploys."
  }, {
    "heading": "解决方案-the-solution",
    "content": "¥The solution"
  }, {
    "heading": "解决方案-the-solution",
    "content": "解决方案是将 Dockerfile 的输入精简为仅包含绝对必要的内容。Turborepo 提供了一个简单的解决方案 - turbo prune。"
  }, {
    "heading": "解决方案-the-solution",
    "content": "¥The solution is to prune the inputs to the Dockerfile to only what is strictly necessary. Turborepo provides a simple solution - turbo prune."
  }, {
    "heading": "解决方案-the-solution",
    "content": "运行此命令会在 ./out 目录中创建一个精简版本的 monorepo。它仅包含 api 所依赖的工作区。它还会修剪锁定文件，以便只下载相关的 node_modules。"
  }, {
    "heading": "解决方案-the-solution",
    "content": "¥Running this command creates a pruned version of your monorepo inside an ./out directory. It only includes workspaces which api depends on. It also prunes the lockfile so that only the relevant node_modules will be downloaded."
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "¥The --docker flag"
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "默认情况下，turbo prune 将所有相关文件放在 ./out 中。但为了优化 Docker 的缓存，理想情况下我们希望分两个阶段复制文件。"
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "¥By default, turbo prune puts all relevant files inside ./out. But to optimize caching with Docker, we ideally want to copy the files over in two stages."
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "首先，我们只想复制安装包所需的内容。运行 --docker 时，你会在 ./out/json 中找到它。"
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "¥First, we want to copy over only what we need to install the packages. When running --docker, you'll find this inside ./out/json."
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "之后，你可以复制 ./out/full 中的文件以添加源文件。"
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "¥Afterwards, you can copy the files in ./out/full to add the source files."
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "以这种方式拆分依赖和源文件，可以让我们仅在依赖发生变化时运行 npm install。 - 带来更大的加速。"
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "¥Splitting up dependencies and source files in this way lets us only run npm install when dependencies change - giving us a much larger speedup."
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "如果没有 --docker，所有修剪的文件都将放置在 ./out 中。"
  }, {
    "heading": "--docker-标志-the---docker-flag",
    "content": "¥Without --docker, all pruned files are placed inside ./out."
  }, {
    "heading": "示例-example",
    "content": "¥Example"
  }, {
    "heading": "示例-example",
    "content": "我们详细的 with-docker 示例 深入介绍了如何充分发挥 prune 的潜力。以下是 Dockerfile，为方便起见，已复制过来。"
  }, {
    "heading": "示例-example",
    "content": "¥Our detailed with-docker example goes into depth on how to use prune to its full potential. Here's the Dockerfile, copied over for convenience."
  }, {
    "heading": "示例-example",
    "content": "从 monorepo 的根目录构建 Dockerfile："
  }, {
    "heading": "示例-example",
    "content": "¥Build the Dockerfile from the root of your monorepo:"
  }, {
    "heading": "示例-example",
    "content": "此 Dockerfile 是为使用 standalone 输出模式 的 Next.js 应用编写的。"
  }, {
    "heading": "示例-example",
    "content": "¥This Dockerfile is written for a Next.js app that is\nusing the standalone output\nmode."
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥Remote Caching"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "要在 Docker 构建期间利用远程缓存，你需要确保你的构建容器具有访问 远程缓存 的凭据。"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥To take advantage of remote caches during Docker builds, you will need to make sure your build container has credentials to access your Remote Cache."
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "有很多方法可以保护 Docker 镜像中的密钥信息。我们将在此使用一种简单的策略，即使用 secret 作为构建参数进行多阶段构建，这些参数将在最终镜像中隐藏。"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥There are many ways to take care of secrets in a Docker image. We will use a simple strategy here with multi-stage builds using secrets as build arguments that will get hidden for the final image."
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "假设你使用的 Dockerfile 与上述类似，我们将在 turbo build 之前从构建参数中引入一些环境变量："
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥Assuming you are using a Dockerfile similar to the one above, we will bring in some environment variables from build arguments right before turbo build:"
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "turbo 现在将能够访问远程缓存。要查看非缓存 Docker 构建镜像的 Turborepo 缓存命中情况，请从项目根目录运行如下命令："
  }, {
    "heading": "远程缓存-remote-caching",
    "content": "¥turbo will now be able to hit your Remote Cache. To see a Turborepo cache hit for a non-cached Docker build image, run a command like this one from your project root:"
  }],
  "headings": [{
    "id": "问题-the-problem",
    "content": "问题 /*the-problem*/"
  }, {
    "id": "锁文件更改过于频繁-the-lockfile-changes-too-often",
    "content": "锁文件更改过于频繁 /*the-lockfile-changes-too-often*/"
  }, {
    "id": "解决方案-the-solution",
    "content": "解决方案 /*the-solution*/"
  }, {
    "id": "--docker-标志-the---docker-flag",
    "content": "--docker 标志 /*the---docker-flag*/"
  }, {
    "id": "示例-example",
    "content": "示例 /*example*/"
  }, {
    "id": "远程缓存-remote-caching",
    "content": "远程缓存 /*remote-caching*/"
  }]
};
import {Callout} from '#components/callout';
import {File, Folder, Files} from '#components/files';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#问题-the-problem",
  title: _jsx(_Fragment, {
    children: "问题 "
  })
}, {
  depth: 3,
  url: "#锁文件更改过于频繁-the-lockfile-changes-too-often",
  title: _jsx(_Fragment, {
    children: "锁文件更改过于频繁 "
  })
}, {
  depth: 2,
  url: "#解决方案-the-solution",
  title: _jsx(_Fragment, {
    children: "解决方案 "
  })
}, {
  depth: 3,
  url: "#--docker-标志-the---docker-flag",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--docker"
    }), " 标志 "]
  })
}, {
  depth: 3,
  url: "#示例-example",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 2,
  url: "#远程缓存-remote-caching",
  title: _jsx(_Fragment, {
    children: "远程缓存 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["构建 ", _jsx(_components.a, {
        href: "https://www.docker.com/",
        children: "Docker"
      }), " 镜像是部署各种应用的常用方法。但是，从 monorepo 执行此操作有几个挑战。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Building a ", _jsx(_components.a, {
        href: "https://www.docker.com/",
        children: "Docker"
      }), " image is a common way to deploy all sorts of applications. However, doing so from a monorepo has several challenges."]
    }), "\n", _jsx(CreateTurboCallout, {}), "\n", _jsx(_components.h2, {
      id: "问题-the-problem",
      children: "问题 "
    }), "\n", _jsx(_components.p, {
      children: "¥The problem"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "在 monorepo 中，不相关的更改可能会导致 Docker 在部署应用时执行不必要的工作。"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "In a monorepo, unrelated changes can make Docker do unnecessary work when deploying your app."
      })]
    }), "\n", _jsx(_components.p, {
      children: "假设你有一个如下所示的 monorepo："
    }), "\n", _jsx(_components.p, {
      children: "¥Let's imagine you have a monorepo that looks like this:"
    }), "\n", _jsxs(Files, {
      children: [_jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "api",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "server.js"
          }), _jsx(File, {
            name: "package.json"
          })]
        }), _jsx(Folder, {
          name: "web",
          defaultOpen: true,
          children: _jsx(File, {
            name: "package.json"
          })
        })]
      }), _jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "package-lock.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["你希望使用 Docker 部署 ", _jsx(_components.code, {
        children: "apps/api"
      }), "，因此你创建了一个 Dockerfile："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You want to deploy ", _jsx(_components.code, {
        children: "apps/api"
      }), " using Docker, so you create a Dockerfile:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/api/Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node:16"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /usr/src/app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy root package.json and lockfile"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " package.json ./"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " package-lock.json ./"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy the api package.json"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apps/api/package.json ./apps/api/package.json"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " npm install"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy app source"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " . ."
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "EXPOSE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " 8080"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "CMD"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [ "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"node\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"apps/api/server.js\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ]"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这会将根 ", _jsx(_components.code, {
        children: "package.json"
      }), " 和根锁定文件复制到 Docker 镜像。然后，它将安装依赖，复制应用源代码并启动应用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This will copy the root ", _jsx(_components.code, {
        children: "package.json"
      }), " and the root lockfile to the Docker image. Then, it'll install dependencies, copy the app source and start the app."]
    }), "\n", _jsxs(_components.p, {
      children: ["你还应该创建一个 ", _jsx(_components.code, {
        children: ".dockerignore"
      }), " 文件，以防止 node_modules 与应用源代码一起复制。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You should also create a ", _jsx(_components.code, {
        children: ".dockerignore"
      }), " file to prevent node_modules from being copied in with the app's source."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".dockerignore",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "node_modules"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "npm-debug.log"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "锁文件更改过于频繁-the-lockfile-changes-too-often",
      children: "锁文件更改过于频繁 "
    }), "\n", _jsx(_components.p, {
      children: "¥The lockfile changes too often"
    }), "\n", _jsxs(_components.p, {
      children: ["Docker 在部署应用方面非常智能。就像 Turborepo 一样，它会尝试执行 ", _jsx(_components.a, {
        href: "https://bitjudo.com/blog/2014/03/13/building-efficient-dockerfiles-node-dot-js/",
        children: "尽可能少的工作"
      }), " 的操作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Docker is pretty smart about how it deploys your apps. Just like Turborepo, it tries to do as ", _jsx(_components.a, {
        href: "https://bitjudo.com/blog/2014/03/13/building-efficient-dockerfiles-node-dot-js/",
        children: "little work as possible"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["在我们的 Dockerfile 中，只有当其镜像中的文件与上次运行的文件不同时，它才会运行 ", _jsx(_components.code, {
        children: "npm install"
      }), "。如果没有，它将恢复之前的 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 目录。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In our Dockerfile's case, it will only run ", _jsx(_components.code, {
        children: "npm install"
      }), " if the files it has in its image are ", _jsx(_components.em, {
        children: "different"
      }), " from the previous run. If not, it'll restore the ", _jsx(_components.code, {
        children: "node_modules"
      }), " directory it had before."]
    }), "\n", _jsxs(_components.p, {
      children: ["这意味着每当 ", _jsx(_components.code, {
        children: "package.json"
      }), "、", _jsx(_components.code, {
        children: "apps/api/package.json"
      }), " 或 ", _jsx(_components.code, {
        children: "package-lock.json"
      }), " 发生更改时，Docker 镜像都会运行 ", _jsx(_components.code, {
        children: "npm install"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This means that whenever ", _jsx(_components.code, {
        children: "package.json"
      }), ", ", _jsx(_components.code, {
        children: "apps/api/package.json"
      }), " or ", _jsx(_components.code, {
        children: "package-lock.json"
      }), " change, the Docker image will run ", _jsx(_components.code, {
        children: "npm install"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["听起来很棒 - 直到我们意识到一些事情。", _jsx(_components.code, {
        children: "package-lock.json"
      }), " 对于 monorepo 来说是全局的。这意味着如果我们在 ", _jsx(_components.code, {
        children: "apps/web"
      }), " 中安装一个新包，就会导致 ", _jsx(_components.code, {
        children: "apps/api"
      }), " 重新部署。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This sounds great - until we realize something. The ", _jsx(_components.code, {
        children: "package-lock.json"
      }), " is ", _jsx(_components.em, {
        children: "global"
      }), " for the monorepo. That means that ", _jsxs(_components.strong, {
        children: ["if we install a new package inside ", _jsx(_components.code, {
          children: "apps/web"
        }), ", we'll cause ", _jsx(_components.code, {
          children: "apps/api"
        }), " to redeploy"]
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "在大型的 monorepo 中，这可能会导致大量时间损失，因为对 monorepo 的 lockfile 的任何更改都会级联到数十或数百个部署中。"
    }), "\n", _jsx(_components.p, {
      children: "¥In a large monorepo, this can result in a huge amount of lost time, as any change to a monorepo's lockfile cascades into tens or hundreds of deploys."
    }), "\n", _jsx(_components.h2, {
      id: "解决方案-the-solution",
      children: "解决方案 "
    }), "\n", _jsx(_components.p, {
      children: "¥The solution"
    }), "\n", _jsxs(_components.p, {
      children: ["解决方案是将 Dockerfile 的输入精简为仅包含绝对必要的内容。Turborepo 提供了一个简单的解决方案 - ", _jsx(_components.code, {
        children: "turbo prune"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The solution is to prune the inputs to the Dockerfile to only what is strictly necessary. Turborepo provides a simple solution - ", _jsx(_components.code, {
        children: "turbo prune"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " prune"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " api"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --docker"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["运行此命令会在 ", _jsx(_components.code, {
        children: "./out"
      }), " 目录中创建一个精简版本的 monorepo。它仅包含 ", _jsx(_components.code, {
        children: "api"
      }), " 所依赖的工作区。它还会修剪锁定文件，以便只下载相关的 ", _jsx(_components.code, {
        children: "node_modules"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Running this command creates a ", _jsx(_components.strong, {
        children: "pruned version of your monorepo"
      }), " inside an ", _jsx(_components.code, {
        children: "./out"
      }), " directory. It only includes workspaces which ", _jsx(_components.code, {
        children: "api"
      }), " depends on. It also ", _jsx(_components.strong, {
        children: "prunes the lockfile"
      }), " so that only the relevant ", _jsx(_components.code, {
        children: "node_modules"
      }), " will be downloaded."]
    }), "\n", _jsxs(_components.h3, {
      id: "--docker-标志-the---docker-flag",
      children: [_jsx(_components.code, {
        children: "--docker"
      }), " 标志 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "--docker"
      }), " flag"]
    }), "\n", _jsxs(_components.p, {
      children: ["默认情况下，", _jsx(_components.code, {
        children: "turbo prune"
      }), " 将所有相关文件放在 ", _jsx(_components.code, {
        children: "./out"
      }), " 中。但为了优化 Docker 的缓存，理想情况下我们希望分两个阶段复制文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥By default, ", _jsx(_components.code, {
        children: "turbo prune"
      }), " puts all relevant files inside ", _jsx(_components.code, {
        children: "./out"
      }), ". But to optimize caching with Docker, we ideally want to copy the files over in two stages."]
    }), "\n", _jsxs(_components.p, {
      children: ["首先，我们只想复制安装包所需的内容。运行 ", _jsx(_components.code, {
        children: "--docker"
      }), " 时，你会在 ", _jsx(_components.code, {
        children: "./out/json"
      }), " 中找到它。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥First, we want to copy over only what we need to install the packages. When running ", _jsx(_components.code, {
        children: "--docker"
      }), ", you'll find this inside ", _jsx(_components.code, {
        children: "./out/json"
      }), "."]
    }), "\n", _jsx(Files, {
      children: _jsxs(Folder, {
        name: "out",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "json",
          defaultOpen: true,
          children: [_jsx(Folder, {
            name: "apps",
            defaultOpen: true,
            children: _jsx(Folder, {
              name: "api",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json"
              })
            })
          }), _jsx(File, {
            name: "package.json"
          })]
        }), _jsxs(Folder, {
          name: "full",
          defaultOpen: true,
          children: [_jsx(Folder, {
            name: "apps",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "api",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "server.js"
              }), _jsx(File, {
                name: "package.json"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        }), _jsx(File, {
          name: "package-lock.json"
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["之后，你可以复制 ", _jsx(_components.code, {
        children: "./out/full"
      }), " 中的文件以添加源文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Afterwards, you can copy the files in ", _jsx(_components.code, {
        children: "./out/full"
      }), " to add the source files."]
    }), "\n", _jsxs(_components.p, {
      children: ["以这种方式拆分依赖和源文件，可以让我们仅在依赖发生变化时运行 ", _jsx(_components.code, {
        children: "npm install"
      }), "。 - 带来更大的加速。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Splitting up ", _jsx(_components.strong, {
        children: "dependencies"
      }), " and ", _jsx(_components.strong, {
        children: "source files"
      }), " in this way lets us ", _jsxs(_components.strong, {
        children: ["only run ", _jsx(_components.code, {
          children: "npm install"
        }), " when dependencies change"]
      }), " - giving us a much larger speedup."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["如果没有 ", _jsx(_components.code, {
          children: "--docker"
        }), "，所有修剪的文件都将放置在 ", _jsx(_components.code, {
          children: "./out"
        }), " 中。"]
      }), _jsxs(_components.p, {
        children: ["¥Without ", _jsx(_components.code, {
          children: "--docker"
        }), ", all pruned files are placed inside ", _jsx(_components.code, {
          children: "./out"
        }), "."]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "示例-example",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Example"
    }), "\n", _jsxs(_components.p, {
      children: ["我们详细的 ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/with-docker",
        children: [_jsx(_components.code, {
          children: "with-docker"
        }), " 示例"]
      }), " 深入介绍了如何充分发挥 ", _jsx(_components.code, {
        children: "prune"
      }), " 的潜力。以下是 Dockerfile，为方便起见，已复制过来。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Our detailed ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/with-docker",
        children: [_jsx(_components.code, {
          children: "with-docker"
        }), " example"]
      }), " goes into depth on how to use ", _jsx(_components.code, {
        children: "prune"
      }), " to its full potential. Here's the Dockerfile, copied over for convenience."]
    }), "\n", _jsx(_components.p, {
      children: "从 monorepo 的根目录构建 Dockerfile："
    }), "\n", _jsx(_components.p, {
      children: "¥Build the Dockerfile from the root of your monorepo:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "docker"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -f"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " apps/web/Dockerfile"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            })]
          })
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["此 Dockerfile 是为使用 ", _jsx(_components.code, {
          children: "standalone"
        }), " ", _jsx(_components.a, {
          href: "https://next.nodejs.cn/docs/pages/api-reference/next-config-js/output",
          children: "输出模式"
        }), " 的 ", _jsx(_components.a, {
          href: "https://next.nodejs.cn/",
          children: "Next.js"
        }), " 应用编写的。"]
      }), _jsxs(_components.p, {
        children: ["¥This Dockerfile is written for a ", _jsx(_components.a, {
          href: "https://next.nodejs.cn/",
          children: "Next.js"
        }), " app that is\nusing the ", _jsx(_components.code, {
          children: "standalone"
        }), " ", _jsx(_components.a, {
          href: "https://next.nodejs.cn/docs/pages/api-reference/next-config-js/output",
          children: "output\nmode"
        }), "."]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node:18-alpine "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk update"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk add --no-cache libc6-compat"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Set working directory"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ---"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " prepare"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Replace <your-major-version> with the major version installed in your repository. For example:"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# RUN yarn global add turbo@^2"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn global add turbo@^<your-major-version>"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " . ."
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Add lockfile and package.json's of isolated subworkspace"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Generate a partial monorepo with a pruned lockfile for a target workspace."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Assuming \"web\" is the name entered in the project's package.json: { name: \"web\" }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " turbo prune web --docker"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ---"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " builder"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# First install the dependencies (as they change less often)"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=prepare /app/out/json/ ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn install"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Build the project"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=prepare /app/out/full/ ."
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Uncomment and use build args to enable remote caching"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ARG TURBO_TEAM"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ENV TURBO_TEAM=$TURBO_TEAM"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ARG TURBO_TOKEN"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ENV TURBO_TOKEN=$TURBO_TOKEN"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn turbo build"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ---"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " runner"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Don't run production as root for security reasons"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " addgroup --system --gid 1001 nodejs"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " adduser --system --uid 1001 nextjs"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "USER"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " nextjs"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Automatically leverage output traces to reduce image size"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# https://next.nodejs.cn/docs/advanced-features/output-file-tracing"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=builder --chown=nextjs:nodejs /app/apps/web/.next/standalone ./"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=builder --chown=nextjs:nodejs /app/apps/web/.next/static ./apps/web/.next/static"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=builder --chown=nextjs:nodejs /app/apps/web/public ./apps/web/public"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "CMD"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node apps/web/server.js"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "远程缓存-remote-caching",
      children: "远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Remote Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["要在 Docker 构建期间利用远程缓存，你需要确保你的构建容器具有访问 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), " 的凭据。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To take advantage of remote caches during Docker builds, you will need to make sure your build container has credentials to access your ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Cache"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "有很多方法可以保护 Docker 镜像中的密钥信息。我们将在此使用一种简单的策略，即使用 secret 作为构建参数进行多阶段构建，这些参数将在最终镜像中隐藏。"
    }), "\n", _jsx(_components.p, {
      children: "¥There are many ways to take care of secrets in a Docker image. We will use a simple strategy here with multi-stage builds using secrets as build arguments that will get hidden for the final image."
    }), "\n", _jsxs(_components.p, {
      children: ["假设你使用的 Dockerfile 与上述类似，我们将在 ", _jsx(_components.code, {
        children: "turbo build"
      }), " 之前从构建参数中引入一些环境变量："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Assuming you are using a Dockerfile similar to the one above, we will bring in some environment variables from build arguments right before ", _jsx(_components.code, {
        children: "turbo build"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/api/Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ARG"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TEAM"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ENV"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TEAM=$TURBO_TEAM"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ARG"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TOKEN"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ENV"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TOKEN=$TURBO_TOKEN"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn turbo run build"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 现在将能够访问远程缓存。要查看非缓存 Docker 构建镜像的 Turborepo 缓存命中情况，请从项目根目录运行如下命令："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " will now be able to hit your Remote Cache. To see a Turborepo cache hit for a non-cached Docker build image, run a command like this one from your project root:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "docker"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -f"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " apps/web/Dockerfile"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --build-arg"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " TURBO_TEAM=“your-team-name”"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --build-arg"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " TURBO_TOKEN=“your-token“"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-cache"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
